export const FORM_CONTAINER_NAME = 'formSchema';
export const FORM_PAGE_NAME = 'FormPage-';
export const FORM_SUBMIT = 'formSubmit';

export const FORM_SCHEMA_PARAM = 'cfm_form';
